import { render } from "./ShopsList.vue?vue&type=template&id=f4f55446&scoped=true"
import script from "./ShopsList.vue?vue&type=script&lang=js"
export * from "./ShopsList.vue?vue&type=script&lang=js"

import "./ShopsList.vue?vue&type=style&index=0&id=f4f55446&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/UltimaMonitor_lgames/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4f55446"]])

export default __exports__